import { Link } from "react-router-dom";

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  status: string;
  rating: number;
  views: number;
  tags: string[];
  chapters: number;
}

export default function ComicCard({ id, title, author, cover, status, rating, views, tags, chapters }: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return (v / 10000).toFixed(1) + "万";
    return v.toString();
  };

  return (
    <Link to={`/comic/${id}`} className="group block cursor-pointer" data-product-shop="">
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100 mb-3">
        <img
          src={cover}
          alt={title + " - 番茄漫画免费在线阅读"}
          title={title + " - 番茄漫画"}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-2 left-2">
          <span className={`text-xs px-2 py-0.5 rounded-full whitespace-nowrap ${
            status === "完结" ? "bg-secondary-500 text-background-50" : "bg-primary-500 text-background-50"
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="text-xs px-2 py-0.5 rounded-full bg-background-950/60 text-background-50 whitespace-nowrap">
            {chapters}话
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-2">
            <span className="text-xs text-background-50/90 flex items-center gap-0.5">
              <i className="ri-star-fill text-yellow-400 text-xs"></i> {rating}
            </span>
            <span className="text-xs text-background-50/70">·</span>
            <span className="text-xs text-background-50/70">{formatViews(views)} 阅读</span>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1 whitespace-nowrap">
        {title}
      </h3>
      <p className="text-xs text-foreground-600 mt-0.5 whitespace-nowrap">{author}</p>
      <div className="flex gap-1 mt-1.5 flex-wrap">
        {tags.slice(0, 3).map((tag) => (
          <span key={tag} className="text-xs px-1.5 py-0.5 rounded bg-background-100 text-foreground-600 whitespace-nowrap">
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}